export const ALIGN_LEFT = 'left'
export const ALIGN_CENTER = 'center'
export const ALIGN_RIGHT = 'right'
